import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['value', 'otherInput']
  static values = {
    otherSentinel: { type: String, default: 'other' }
  }

  choose(event) {
    const radio = event.target
    if (this.isOther(radio.value)) {
      this.valueTarget.value = this.otherInputTarget.value
      this.otherInputTarget.focus()
    } else {
      this.valueTarget.value = radio.value
    }
  }

  syncOther(event) {
    if (!this.otherActive()) return
    this.valueTarget.value = event.target.value
  }

  otherActive() {
    const checked = this.element.querySelector('input[type=radio]:checked')
    return checked && this.isOther(checked.value)
  }

  isOther(value) {
    return value === this.otherSentinelValue
  }
}
